import React from 'react';
import Navbar from '../Navbar/Navbar';
import { Link } from "react-router-dom";
import baig1 from '../../../images/baig/shohelrana-baig.jpg';
import './About.css';
const About = () => {
    return (
        <div>
            <Navbar></Navbar>
            <div className="container about-me py-5">
                <div className="header text-center">
                    <h2>ABOUT <span>ME</span></h2>
                    <div className="wrapper">
                        <div className="divider div-transparent div-dot"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 my-5 animate__animated animate__fadeInTopLeft">
                        <div className="my-pic text-center">
                            <img className="img-fluid"
                                style={{ height: "230px", width: "230px", borderRadius: '50%', padding: '5px', border: "3px solid #ffffff " }}
                                src={baig1} alt="" />
                        </div>
                        <div className="my-4" style={{ lineHeight: "1.7", textAlign: "justify" }}>
                            <h2>I'm Shohel Rana</h2>
                            <p>
                                I am a highly passionate, enthusiastic, hardworking and dedicated learner. Self-motivated IT professional with
                                deep knowledge and proficiency in JavaScript, HTML, CSS, and mobile responsive website development, as
                                well as highly potent skills and ability in encoding virus-free and efficient code. I have a strong passion for the creativity and discipline that goes into front-end development. 
                                Keeping in mind scalability and clean code that is maintainable and readable.
                            </p>
                        </div>
                        <div className="">
                            <Link to="/contact">
                                <button style={{ backgroundColor: "#e9af1d", color: "black" }} className="btn mr-3 font-weight-bold ">Contact Me</button>
                            </Link>
                            <Link to="/blogs">
                                <button style={{ backgroundColor: "#e9af1d", color: "black" }} className="btn font-weight-bold">My Blogs</button>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 my-5 animate__animated animate__fadeInBottomRight">
                        <h2 className="text-center">My Skills</h2>
                        <div className="my-5">
                            <h4>Comfortable</h4>
                            <div className="skills my-3">
                                <span>HTML</span>
                                <span>CSS</span>
                                <span>Javascript</span>
                                <span>ES6</span>
                                <span>React</span>
                                <span>Bootstrap</span>
                                <span>Material-UI</span>
                                <span>SASS</span>
                                <span>Ant Design</span>
                                <span>TypeScript</span>
                                <span>Next.js</span>
                                <span>Chakra-UI</span>
                                <span>Tailwindcss</span>
                            </div>
                        </div>
                        <div className="my-5">
                            <h4>Familiar</h4>
                            <div className="skills my-3">
                                <span>MongoDB</span>
                                <span>Express.js</span>
                                <span>Node.js</span>
                                <span>GraphQL</span>
                                <span>Redux</span>
                                <span>Data Structure</span>
                                <span>Java</span>
                                <span>OOP</span>
                                <span>Algorithm</span>
                            </div>
                        </div>
                        <div className="my-5">
                            <h4>Tools &amp; Platform</h4>
                            <div className="skills my-3">
                                <span>Visual Studio Code</span>
                                <span>Git</span>
                                <span>GitHub</span>
                                <span>Bitbucket</span>
                                <span>Npm</span>
                                <span>Yarn</span>
                                <span>Firebase</span>
                                <span>Netlify</span>
                                <span>Heroku</span>
                                <span>Vercel</span>
                                <span>Jira</span>
                                <span>Chrome Dev Tool</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;